<template>
  <v-app dark>
    <component :is="layout">
      <router-view/>
    </component>
  </v-app>
</template>

<script>
import { STATS_SET_PERIOD } from '@/store/actions/stats';
import { SYSTEM_SERVER_INFO } from '@/store/actions/system';

const DEFAULT_LAYOUT = 'default';

export default {
  name: 'App',

  mounted () {
    this.$store.dispatch(SYSTEM_SERVER_INFO);
    this.$store.dispatch(STATS_SET_PERIOD, 'week');
  },

  computed: {
    layout () {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + '-layout';
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/style.scss';
</style>
